import React, { useEffect, useState } from "react";
import tw from "tailwind-styled-components";
import { useFormik } from "formik";
import moment from "moment";
import { toast } from "react-toastify";
import { Select, MenuItem } from "@mui/material";
import { FaRegCalendar } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  InputGroup,
  FieldWrappers,
  Label,
  SubmitBtn,
  SideCancelBtn,
  Wrapper,
  ScrollableContent,
  ActionSection,
  RupeeIcon,
  CombineInputGroup,
  Note,
} from "../Styles/InputStyles";
import { MdOutlineInfo } from "react-icons/md";
const AdvanceRent = ({
  tenantId,
  selectedOption,
  setSelectedOption,
  addDuesMutate,
  addDuesLoading,
  rentStartDateOld,
  advanceRentSlots
}) => {
  const [startDateOpen, setStartDateOpen] = useState(false);
  const [endDateOpen, setEndDateOpen] = useState(false);
  const [dueDateOpen, setDueDateOpen] = useState(false);
  const [rentData, setRentData] = useState();
  const [rentStartDate, setRentStartDate] = useState(advanceRentSlots[0].rentStartDate);

  const formattedDate = new Date(rentStartDate).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
  const formik = useFormik({
    initialValues: {
      amount: "",
      startDate: rentStartDate || "",
      dueDate: "",
      endDate: "",
      description: "",
      rentDuration: "",
      rentalMonthAdd: "",
    },

    onSubmit: (values) => {
      if (!values.amount) {
        toast.error("Please enter amount");
        return;
      }
      if (values.amount <= 0) {
        toast.error("Amount must be greater than 0");
        return;
      }

      if (values.amount > 1000000) {
        toast.error("Amount cannot be greater than 10,00,000");
        return;
      }
      if (!values.startDate) {
        toast.error("Please select start date");
        return;
      }
      if (!values.dueDate) {
        toast.error("Please select due date");
        return;
      }

      if (!values.rentDuration) {
        toast.error("Please enter rent duration");
        return;
      }
      if (!values.endDate) {
        toast.error("Please select end date");
        return;
      } else if (new Date(values.endDate) < new Date(values.startDate)) {
        toast.error("End date cannot be earlier than start date");
        return;
      }

      addDuesMutate({
        amount: Number(values.amount),
        startDate: moment(values.startDate).format("YYYY-MM-DD"),
        dueDate: moment(values.dueDate).format("YYYY-MM-DD"),
        endDate: values.endDate
          ? moment(values.endDate).format("YYYY-MM-DD")
          : null,
        description: values.description,
        rentDuration: values.rentalMonthAdd,
        type: Number(selectedOption),
        tenantId: tenantId,
        title: "Advance Rent",
      });
    },
  });

  const selectedRentSlot = React.useMemo(() => {
    const duration = Number(formik.values.rentDuration);
    if (!duration || duration < 1 || duration > advanceRentSlots.length) {
      return null;
    }
    return advanceRentSlots[duration - 1];
  }, [formik.values.rentDuration, advanceRentSlots]);

  useEffect(() => {
    if (!selectedRentSlot) return;

    formik.setValues((prev) => ({
      ...prev,
      startDate: moment(selectedRentSlot.rentStartDate).format("YYYY-MM-DD"),
      endDate: moment(selectedRentSlot.rentEndDate).format("YYYY-MM-DD"),
      rentalMonthAdd: selectedRentSlot.rentalMonthAdd
    }));
  }, [selectedRentSlot]);

  const handleRentDurationChange = (event) => {
    const duration = event.target.value;
    formik.setFieldValue("rentDuration", duration);

    const slot = advanceRentSlots.find(slot => slot.rentDuration.toString() === duration);
    if (slot) {
      formik.setFieldValue("rentalMonthAdd", slot.rentalMonthAdd);
    }
  };
  return (
    <Container>
      <form
        className="px-1  flex flex-col gap-4"
        onSubmit={formik.handleSubmit}
      >
        <ScrollableContent className="!max-h-[calc(100vh-200px)]">
          <Wrapper>
            {/* Rent Duration */}
            <InputGroup>
              <Label htmlFor="rentDuration">Rent Duration *</Label>
              <Select
                value={formik.values.rentDuration}
                onChange={handleRentDurationChange}
                id="rentDuration"
                displayEmpty
                className="w-full px-2"
                style={{ height: "46px" }}
              >
                <MenuItem value="" disabled>
                  <Label>Select Rent Duration</Label>
                </MenuItem>
                {advanceRentSlots.map((slot) => (
                  <MenuItem key={slot.rentDuration} value={slot.rentDuration.toString()}>
                    {slot.rentDuration} Month{slot.rentDuration > 1 ? 's' : ''}
                  </MenuItem>
                ))}
                {/* <MenuItem value="1">1 Month</MenuItem>
                <MenuItem value="2">2 Months</MenuItem>
                <MenuItem value="3">3 Months</MenuItem>
                <MenuItem value="4">4 Months</MenuItem>
                <MenuItem value="5">5 Months</MenuItem>
                <MenuItem value="6">6 Months</MenuItem>
                <MenuItem value="7">7 Months</MenuItem>
                <MenuItem value="8">8 Months</MenuItem>
                <MenuItem value="9">9 Months</MenuItem>
                <MenuItem value="10">10 Months</MenuItem>
                <MenuItem value="11">11 Months</MenuItem>
                <MenuItem value="12">12 Months</MenuItem> */}
              </Select>
              <Note>
                <MdOutlineInfo className="mt-0.5 mr-1" />
                Tenant has already paid rent untill {formattedDate}
              </Note>
            </InputGroup>

            {/* Amount */}
            <InputGroup>
              <Label htmlFor="amount">Amount *</Label>
              <FieldWrappers>
                <RupeeIcon />
                <input
                  type="text"
                  id="amount"
                  placeholder="Enter Amount"
                  min={1}
                  max={1000000}
                  inputMode="numeric"
                  pattern="[0-9]*"
                  {...formik.getFieldProps("amount")}
                  // onKeyDown={(e) => {
                  //   if (!/^\d$/.test(e.key) && e.key !== "Backspace") {
                  //     e.preventDefault();
                  //   }
                  // }}
                  className="pl-6"
                />
              </FieldWrappers>
            </InputGroup>

            {/* Date and Due Date */}
            <CombineInputGroup className="gap-4 md:gap-0">
              <InputGroup>
                <Label htmlFor="startDate">Start Date *</Label>
                <FieldWrappers>

                  <DatePicker
                    selected={formik.values.startDate ? new Date(formik.values.startDate) : null}
                    onChange={(date) => {
                      formik.setFieldValue("startDate", moment(date).format("YYYY-MM-DD"));
                      setStartDateOpen(false);
                    }}
                    onClickOutside={() => setStartDateOpen(false)}
                    onSelect={() => setStartDateOpen(false)}
                    open={startDateOpen}
                    onInputClick={() => setStartDateOpen(true)}
                    dateFormat="yyyy-MM-dd"
                    className="w-full items-center"
                    placeholderText="Select start date"
                    showIcon
                    icon={<FaRegCalendar className="text-gray-400 text-xs mt-0.5" />}
                    showPopperArrow={false}
                    disabled
                    wrapperClassName="w-full"
                    name="startDate"
                    id="startDate"
                    autoComplete="off"
                    onFocus={(e) => e.target.blur()}
                    popperPlacement="bottom-start"
                    portalId="root-portal"
                    popperClassName="react-datepicker-popper"
                  />
                </FieldWrappers>
              </InputGroup>
              <InputGroup>
                <Label htmlFor="endDate">End Date *</Label>
                <FieldWrappers>

                  <DatePicker
                    selected={formik.values.endDate ? new Date(formik.values.endDate) : null}
                    onChange={(date) => {
                      formik.setFieldValue("endDate", moment(date).format("YYYY-MM-DD"));
                      setEndDateOpen(false);
                    }}
                    onClickOutside={() => setEndDateOpen(false)}
                    onSelect={() => setEndDateOpen(false)}
                    open={endDateOpen}
                    onInputClick={() => setEndDateOpen(true)}
                    dateFormat="yyyy-MM-dd"
                    className="items-center cursor-pointer"
                    placeholderText="Select end date"
                    showIcon
                    icon={<FaRegCalendar className="text-gray-400 text-xs mt-0.5" />}
                    showPopperArrow={false}
                    minDate={formik.values.startDate ? new Date(formik.values.startDate) : null}
                    disabled
                    wrapperClassName="w-full"
                    name="endDate"
                    id="endDate"
                    autoComplete="off"
                    onFocus={(e) => e.target.blur()}
                    popperPlacement="bottom-start"
                    portalId="root-portal"
                    popperClassName="react-datepicker-popper"
                  />
                </FieldWrappers>
              </InputGroup>
            </CombineInputGroup>
            <CombineInputGroup>
              <InputGroup>
                <Label htmlFor="dueDate">Due Date *</Label>
                <FieldWrappers>

                  <DatePicker
                    selected={formik.values.dueDate ? new Date(formik.values.dueDate) : null}
                    onChange={(date) => {
                      formik.setFieldValue("dueDate", moment(date).format("YYYY-MM-DD"));
                      setDueDateOpen(false);
                    }}
                    onClickOutside={() => setDueDateOpen(false)}
                    onSelect={() => setDueDateOpen(false)}
                    open={dueDateOpen}
                    onInputClick={() => setDueDateOpen(true)}
                    dateFormat="yyyy-MM-dd"
                    className="items-center cursor-pointer"
                    placeholderText="Select due date"
                    showIcon
                    icon={<FaRegCalendar className="text-gray-400 text-xs mt-0.5" />}
                    showPopperArrow={false}
                    wrapperClassName="w-full"
                    name="dueDate"
                    id="dueDate"
                    autoComplete="off"
                    onFocus={(e) => e.target.blur()}
                    popperPlacement="bottom-start"
                    portalId="root-portal"
                    popperClassName="react-datepicker-popper"
                  />
                </FieldWrappers>
              </InputGroup>
            </CombineInputGroup>

            {/* Description */}
            <InputGroup>
              <Label htmlFor="description">Description </Label>
              <FieldWrapper>
                <Textarea
                  id="description"
                  placeholder="Enter Description"
                  {...formik.getFieldProps("description")}
                  rows={3}
                />
              </FieldWrapper>
            </InputGroup>
          </Wrapper>
        </ScrollableContent>

        {/* Action Buttons */}
        <ActionSection>
          <SideCancelBtn type="button" onClick={() => setSelectedOption(null)}>
            Back
          </SideCancelBtn>
          <SubmitBtn type="submit" disabled={addDuesLoading}>
            {addDuesLoading ? "Loading..." : "Add Dues"}
          </SubmitBtn>
        </ActionSection>
      </form>
    </Container>
  );
};

const FieldWrapper = tw.div`w-full`;
const Container = tw.div`bg-white w-full h-full flex flex-col`;
const Textarea = tw.textarea`min-h-30 border rounded pl-2 py-2 w-full h-30 resize-y  break-words overflow-hidden`;

export default AdvanceRent;
